
import React from "react";
import ColorSquareIcon from "@/components/icons/ColorSquareIcon";

interface RelatedContentHeaderProps {
  collectionColor: string;
  collectionName: string;
}

const RelatedContentHeader = ({ collectionColor, collectionName }: RelatedContentHeaderProps) => {
  return (
    <div className="flex items-center gap-2">
      <ColorSquareIcon color={collectionColor} size={18} />
      <h2 className="text-[24px] font-semibold">{collectionName}</h2>
    </div>
  );
};

export default RelatedContentHeader;
